import { ReactElement } from 'react';
import { AgwRestApi } from '@localstack/types';
import { getSchema } from '@localstack/services';

import { ListItem, ListItemText } from '@mui/material';

import { MagicDetails } from '../../../magic/MagicDetails';
import { CodeSnippetViewer } from '../../../../display/CodeSnippetViewer';
import { decodeAgwPolicyDocument } from '../utils';

export interface AgwRestApiDetailsProps {
  api?: Optional<Partial<AgwRestApi>>;
}

export const AgwRestApiDetails = ({ api }: AgwRestApiDetailsProps): ReactElement => (
  <MagicDetails
    data={api}
    schema={getSchema('APIGateway')}
    entry="RestApi"
    title="API Details"
    externalFields={{
      '^policy$': (data: string, fieldName: string) =>
        data ? (
          <ListItem key={fieldName}>
            <CodeSnippetViewer data={decodeAgwPolicyDocument(data)} />
          </ListItem>
        ) : (
          <ListItem key={fieldName}>
            <ListItemText primary={fieldName} secondary={data} />
          </ListItem>
        ),
    }}
  />
);
